import type { Accept } from 'react-dropzone';
import { AllowedImageFileExtensions } from 'src/types';

/**
 * Returns the accepted dropzone files we expect as images
 * @returns the dropzone specific shape for accepted files
 */
export function getAcceptedDropzoneFiles(): Accept {
  return Object.entries(AllowedImageFileExtensions).reduce<Accept>(
    (acceptedFiles, [, extension]) => {
      acceptedFiles[`image/${extension}`] = [extension];
      return acceptedFiles;
    },
    {},
  );
}
